import { getConfig } from "@jti/fe-common";

import { buildEvoClientConfig, type EvoClientParams } from "../shared/createEvoClient";
import { createClient as createV5Client, createConfig as createV5Config } from "../v5/__generated__/client";
import { createClient as createV6Client, createConfig as createV6Config } from "../v6/__generated__/client";

export type EvoVersion = "v5" | "v6";

export type UnifiedEvoClientParams = EvoClientParams & {
  version?: EvoVersion;
};

const clientVersionMap = new WeakMap<object, EvoVersion>();

export const getClientVersion = (client: object): EvoVersion => clientVersionMap.get(client) ?? "v5";

export const createEvoClient = ({ version, ...params }: UnifiedEvoClientParams) => {
  const resolvedVersion = version ?? getConfig().EVO_VERSION ?? "v5";
  const deps =
    resolvedVersion === "v6"
      ? { createClient: createV6Client, createConfig: createV6Config }
      : { createClient: createV5Client, createConfig: createV5Config };

  const client = deps.createClient(buildEvoClientConfig(deps, params));
  clientVersionMap.set(client, resolvedVersion);
  return client;
};
